<template>
  <el-dropdown placement="bottom-end" trigger="click">
    <div class="pagoda-layout__user-info">
      <img
        v-if="avatar"
        class="pagoda-layout__avatar"
        :src="avatar"
      /><i v-else class="pagoda-layout__avatar pd-icon-avatar"></i
      ><span class="pagoda-layout__user-name">{{userName}}</span
      ><i class="arrow-down-icon el-icon-arrow-down"></i>
    </div>
    <el-dropdown-menu class="pagoda-layout-user-info" slot="dropdown" ref="dropDown">
      <div class="content">
        <div class="user-info">
          <div class="info">
            <div class="info-item">
              <label
                class="info-item__label"
                :style="labelStyle"
              >
                <img
                  v-if="avatar"
                  class="avatar"
                  :src="avatar"
                />
                <i v-else class="avatar pd-icon-avatar"></i>
              </label
              ><span class="user-name">{{userName}}</span>
            </div>
            <div
              v-for="infoItem in info"
              class="info-item more-info"
              :key="infoItem.name"
            >
              <label class="info-item__label" :style="labelStyle">{{infoItem.name}}：</label
              ><span class="info-item__content">{{infoItem.content}}</span>
            </div>
          </div>
        </div>
        <div class="operate">
          <div
            v-for="operateItem in operate"
            class="operate-item"
            :key="operateItem.name"
          >
            <span @click="handleClick(() => onOperateItemClick(operateItem))">{{operateItem.name}}</span>
        </div>
        </div>
      </div>
      <div class="logout">
        <span @click="handleClick(onLogout)">退出登录</span>
      </div>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
  import {
    getEmptyArray,
    noop
  } from "../../../utils";

  export default {
    name: 'LayoutUserInfo',
    props: {
      avatar: String,
      userName: {
        type: String
      },
      info: {
        type: Array,
        default: getEmptyArray
      },
      operate: {
        type: Array,
        default: getEmptyArray
      },
      infoLabelWidth: {
        type: Number,
        default: 60
      },
      onLogout: Function,
      onOperateItemClick: Function
    },
    computed: {
      labelStyle () {
        return {
          width: `${this.infoLabelWidth}px`
        }
      }
    },
    methods: {
      handleClick (cb) {
        this.$refs.dropDown.dropdown.hide()

        cb()
      }
    }
  }
</script>
